'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIGNIFICANCE = exports.chromosomesWithCumulativeLengths = exports.chromosomeNames = exports.getCytoband = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _GRCh = require('./GRCh38');

var _GRCh2 = _interopRequireDefault(_GRCh);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// get the cytoband of a position on a chromosome
var getCytoband = exports.getCytoband = function getCytoband(chromosome, position) {
  var chrom = _GRCh2.default.top_level_region.find(function (d) {
    return d.name === chromosome;
  });
  if (chrom) {
    var band = chrom.bands.find(function (d) {
      return d.start <= position && d.end > position;
    });
    if (band) {
      var _band$id$split = band.id.split('.'),
          _band$id$split2 = _slicedToArray(_band$id$split, 1),
          major = _band$id$split2[0];

      return '' + chrom.name + major;
    } else {
      return null;
    }
  }
  return null;
};

// ignore Y, MT and patches
var chromosomesNumeric = [];
for (var i = 0; i < 22; i++) {
  chromosomesNumeric.push('' + (i + 1));
}
var chromosomeNames = exports.chromosomeNames = [].concat(chromosomesNumeric, ['X', 'Y']);

// calculate chromosomes with cumulative lengths (also as fraction)
var chromosomesWithLengths = chromosomeNames.map(function (chr) {
  var chrom = _GRCh2.default.top_level_region.find(function (d) {
    return d.name === chr;
  });
  return { name: chr, length: chrom.length };
});
var totalLength = chromosomesWithLengths.reduce(function (acc, d) {
  acc += d.length;
  return acc;
}, 0);
var cumLength = 0;
var chromosomesWithCumulativeLengths = exports.chromosomesWithCumulativeLengths = chromosomesWithLengths.reduce(function (acc, d) {
  cumLength += d.length;
  acc.push(_extends({}, d, {
    cumulativeLength: cumLength,
    proportionalStart: (cumLength - d.length) / totalLength,
    proportionalEnd: cumLength / totalLength
  }));
  return acc;
}, []);

var SIGNIFICANCE = exports.SIGNIFICANCE = -Math.log10(5e-8);